import React from 'react';
import { useTranslation } from 'react-i18next';

const CheckIcon = ({ size = 20, className = '' }: { size?: number; className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

const XIcon = ({ size = 20, className = '' }: { size?: number; className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);

export const ProblemSolutionSection = React.memo(() => {
  const { t } = useTranslation();
  const antes = t('landing.problem.antes', { returnObjects: true }) as string[];
  const com = t('landing.problem.com', { returnObjects: true }) as string[];

  return (
    <section className="py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-xs font-semibold uppercase tracking-widest text-gray-500">{t('landing.problem.eyebrow')}</span>
          <h2
            className="text-3xl md:text-5xl font-medium mt-3 mb-5"
            style={{
              background: 'linear-gradient(to bottom, #000000, #000000, rgba(0, 0, 0, 0.6))',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              letterSpacing: '-0.04em',
            }}
          >
            {t('landing.problem.titleLine1')}
            <br />
            {t('landing.problem.titleLine2')}
          </h2>
          <p className="text-base max-w-2xl mx-auto text-gray-500">{t('landing.problem.subtitle')}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          <div className="bg-gray-50 border border-gray-200 rounded-2xl p-8">
            <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-red-50 mb-5">
              <XIcon size={20} className="text-red-500" />
            </div>
            <h3 className="text-xl font-semibold mb-4 text-black">{t('landing.problem.antesTitle')}</h3>
            <ul className="space-y-3">
              {antes.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-gray-600">
                  <span className="mt-1 inline-block w-1.5 h-1.5 rounded-full bg-red-400 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-black text-white rounded-2xl p-8 shadow-xl shadow-black/10">
            <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/10 mb-5">
              <CheckIcon size={20} className="text-white" />
            </div>
            <h3 className="text-xl font-semibold mb-4">{t('landing.problem.comTitle')}</h3>
            <ul className="space-y-3">
              {com.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-white/80">
                  <CheckIcon size={16} className="text-white mt-0.5 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
});
ProblemSolutionSection.displayName = 'ProblemSolutionSection';
